import {Panes, Select, TextField} from '@management-ui/core';
import React from 'react';

const Fields = ({contact = {}, prefix = ''}) => (
  <Panes
    entity={contact}
    prefix={prefix}
    panes={[
      {
        title: 'Scorpion IDs',
        fields: [
          <TextField
            name="scorpion_customer"
            prefix={prefix}
            label="Customer ID"
          />,
          <TextField
            name="scorpion_user"
            prefix={prefix}
            label="User ID"
          />,
          <Select
            name="scorpion_brand"
            prefix={prefix}
            options={[
              {title: 'Scorpion', value: 'scorpion'},
              {title: 'Safe Track', value: 'safetrack'}
            ]}
            label="Brand"
          />,
        ]
      }
    ]}
    title=""/>
);

export default Fields;

